import {
    CreateBlockVueDomV3,
    createRecord,
    CreateWidgetFromFirebaseNode
} from "../components/v3/lib/vue-dom-obj";


import {PageEngineCommands} from "./AddSectionCommand";

/**
 * Handles Section Removal Actions
 */
export class RemoveSectionCommand extends PageEngineCommands {
    constructor(pageEngineComponent, idx, sectionNode) {
        super();
        this._pageEngineComponent = pageEngineComponent
        this._sectionNode = sectionNode
        this._widget = CreateWidgetFromFirebaseNode(sectionNode)
        this.idx = idx
    }

    get hasChanges () {
        return true
    }

    async execute() {
        this.firebaseRef.splice(this.idx, 1).then((value) => {

            this.removeBlock(this._sectionNode.data.props.vnodeId)

            this.$nextTick(() => {
                let node = document.getElementById(this._sectionNode.data.props.vnodeId)
                node.scrollIntoView({ behavior: 'smooth'})
                this._pageEngineComponent.$mount()
            });
        });
    }

    async unExecute() {
        this.firebaseRef.splice(this.idx, 0, this._widget).then((value) => {

            const vdom = createRecord(value.snapshot)
            const children = vdom.children || vdom['.value']

            let newRecord = CreateBlockVueDomV3( children[this.idx], `${this.idx}`, vdom['.path'])

            this.addBlockAtPosition(newRecord.data.props.vnodeId, newRecord, this.idx);

            this.$nextTick(() => {
                let node = document.getElementById(this._sectionNode.data.props.vnodeId)
                node.scrollIntoView({ behavior: 'smooth'})
                this._pageEngineComponent.$mount()
            });
        })
    }
}